import actions from './actions'
import mutations from './mutation'
import Cookies from 'js-cookie'

const state = {
  language: Cookies.get('lang') || 'zh',
  device: 'desktop',
  breadListState: [],
  userInfo: {},
  menus: {},
  btns: {},
  allFuncs: {},
  themeName: 'defaultTheme',
  decodeValue: false,
  newContentAlert: {}
}

export default {
  state,
  actions,
  mutations
}
